import { ItemCategoryState } from 'src/types/redux';
import {
  FETCH_ITEM_CATEGORY_FAILURE,
  FETCH_ITEM_CATEGORY_REQUEST,
  FETCH_ITEM_CATEGORY_SUCCESS,
  ItemCategoryActionType,
} from '../types/itemCategoryType';

const initialState: ItemCategoryState = {
  loading: false,
  categoryData: [],
  error: '',
};

export const itemCategoryReducer = (
  state = initialState,
  action: ItemCategoryActionType
): ItemCategoryState => {
  switch (action.type) {
    case FETCH_ITEM_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryData: action.payload,
      };
    case FETCH_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
